<h2 mat-dialog-title>Dodaj dodatek/potrącenie</h2>

<mat-dialog-content>
	@if (loadingRefData()) {
		<div class="dialog-loading">
			<mat-spinner diameter="28"></mat-spinner>
		</div>
	} @else {
		<form [formGroup]="form" class="bonus-form">
			<mat-form-field appearance="outline" subscriptSizing="dynamic">
				<mat-label>Typ</mat-label>
				<mat-select formControlName="settlementBonusNameId">
					@for (type of types(); track type.id) {
						<mat-option [value]="type.id">{{ type.name }}</mat-option>
					}
				</mat-select>
				@if (selectedTypeHint()) {
					<mat-hint>{{ selectedTypeHint() }}</mat-hint>
				}
			</mat-form-field>

			<div class="form-row">
				<mat-form-field appearance="outline" subscriptSizing="dynamic" class="field-value">
					<mat-label>Wartość</mat-label>
					<input matInput type="number" step="0.01" min="0" formControlName="value" />
				</mat-form-field>
				<mat-form-field appearance="outline" subscriptSizing="dynamic" class="field-currency">
					<mat-label>Waluta</mat-label>
					<mat-select formControlName="valueCurrencyId">
						@for (currency of currencies(); track currency.id) {
							<mat-option [value]="currency.id">{{ currency.label }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>
			<p class="form-hint">Podaj kwotę dodatnią — typ decyduje o znaku</p>

			<mat-form-field appearance="outline" subscriptSizing="dynamic">
				<mat-label>Data</mat-label>
				<input matInput [matDatepicker]="datePicker" formControlName="date" />
				<mat-datepicker-toggle matIconSuffix [for]="datePicker"></mat-datepicker-toggle>
				<mat-datepicker #datePicker></mat-datepicker>
			</mat-form-field>

			<mat-form-field appearance="outline" subscriptSizing="dynamic">
				<mat-label>Komentarz</mat-label>
				<input matInput type="text" formControlName="comment" />
			</mat-form-field>
		</form>
	}
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button type="button" (click)="onCancel()" [disabled]="saving()">Anuluj</button>
	<button
		mat-raised-button
		color="primary"
		type="button"
		(click)="onSave()"
		[disabled]="saving() || loadingRefData()"
	>
		@if (saving()) {
			<mat-spinner diameter="18" class="me-2 d-inline-block"></mat-spinner>
		}
		Zapisz
	</button>
</mat-dialog-actions>
